import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withMemo as _withMemo, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "text-raleway-20 t-blue mb-2 mr-3 title-details contact-details" }
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "mr-2 input-slim first-name" }
const _hoisted_5 = { class: "account-select-double mr-2 title-data account" }
const _hoisted_6 = { class: "uppercase text-raleway-13" }
const _hoisted_7 = { class: "d-flex" }
const _hoisted_8 = { class: "uppercase text-raleway-13" }
const _hoisted_9 = { class: "uppercase text-raleway-13" }
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "uppercase text-raleway-13" }
const _hoisted_12 = { class: "uppercase text-raleway-13" }
const _hoisted_13 = { class: "d-flex direction-column a-i-center mt-4" }
const _hoisted_14 = { class: "wrapper-scheldules-title" }
const _hoisted_15 = { class: "pb-1" }
const _hoisted_16 = { class: "uppercase text-raleway-13 no-select" }
const _hoisted_17 = { class: "mt-2 mb-2" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

import { LocationDataComponentValidation } from "@/utils/validation/accauntDetailsValidation/locationDataComponent";
import { LocationsAccountsDetails } from "@/store/modules/accountDetails/type";
import SelectComponent from "@/components/select/SelectComponent.vue";
import { UserTypeOperation } from "@/store/modules/User/type";
import { Field, useForm } from "vee-validate";
import { IStore } from "@/store/types/StoreType";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";

import PhoneComponent from "@/components/phone/phoneComponent.vue";
import AllUserComponent from "./allUsers/allUserComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'locationDataComponent',
  setup(__props) {

const title = ref([
  { id: 1, name: "Mr" },
  { id: 2, name: "Mrs" },
  { id: 3, name: "Ms" },
]);

const store = useStore<IStore>();
const initialValues = ref<LocationsAccountsDetails>(
  store?.getters?.getLocationsDataComponentValuesAccountDetails
);

const { meta, errors, values, resetForm, validate } =
  useForm<LocationsAccountsDetails>({
    initialValues: initialValues,
    validationSchema: LocationDataComponentValidation,
  });

const errorValues = ref();
const allErrors = ref();

watch(
  () => store.getters?.getGlobalErrorsLocationsDataComponent || [],
  (value) => {
    allErrors.value = value;
    errorValues.value = allErrors.value.map((value: any) =>
      Array.isArray(Object.keys(value))
        ? Object.keys(value)[0]
        : Object.keys(value)
    );
  },
  {
    deep: true,
  }
);

const addForm = inject<any>("ADD_FORM");

addForm({
  position: 2,
  initialValues,
  meta,
  errors,
  values,
  validate,
  resetForm,
});

const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
const updateTitle = (options: string) =>
  (values.title = options);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", {
      class: "location-details wrapper-details-data",
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_unref(validate)()), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$tc("contact_details")), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$tc("Title")), 1),
              _createVNode(SelectComponent, {
                size: 13,
                name: 'title',
                updateMyValueSelect: updateTitle,
                myValueSelect: title.value[+(_unref(values).title || '1') - 1]?.name,
                default: '',
                "key-or-value": true,
                options2: title.value,
                options: []
              }, null, 8, ["myValueSelect", "options2"])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withMemo([uiLang.value, _unref(values)?.first_name, _unref(errors)?.first_name], () => (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["mr-2 input-slim first-name", { 'error-input mini': !!_unref(errors)?.first_name }])
            }, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$tc("first name")), 1),
              _createVNode(_unref(Field), {
                tabindex: 13,
                maxlength: "30",
                type: "text",
                name: "first_name",
                class: "input input-mini",
                value: _unref(values)?.first_name || '',
                placeholder: _ctx.$tc('first name')
              }, null, 8, ["value", "placeholder"])
            ], 2)), _cache, 0),
            _withMemo([uiLang.value, _unref(values)?.last_name, _unref(errors)?.last_name], () => (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["input-slim", { 'error-input mini': !!_unref(errors)?.last_name }])
            }, [
              _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$tc("last name")), 1),
              _createVNode(_unref(Field), {
                tabindex: 14,
                maxlength: "30",
                type: "text",
                name: "last_name",
                class: "input input-mini",
                value: _unref(values)?.last_name || '',
                placeholder: _ctx.$tc('last name')
              }, null, 8, ["value", "placeholder"])
            ], 2)), _cache, 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", {
            class: _normalizeClass(["mb-3 mr-2 input-slim", {
            'error-input mini': !!_unref(errors)?.user_phone || errorValues.value?.some((value) => value ==='phone'),
          }])
          }, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$tc("phone number")), 1),
            _createVNode(PhoneComponent, {
              tabindex: 15,
              class: _normalizeClass({
              'error-input_phone': !!_unref(errors)?.user_phone,
            }),
              value: initialValues.value?.user_phone || '',
              name: 'user_phone',
              start: initialValues.value.user_phone_start,
              change: 'changeStartValue_user_phone_start'
            }, null, 8, ["class", "value", "start"])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["mr-2 input-slim mail", {
            'error-input mini': !!_unref(errors)?.email || errorValues.value?.some((value) => value ==='email'),
          }])
          }, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$tc("Email address")), 1),
            _createVNode(_unref(Field), {
              tabindex: 16,
              maxlength: "55",
              type: "text",
              name: "email",
              class: "input input-mini mb-1",
              placeholder: _ctx.$tc('Email address')
            }, null, 8, ["placeholder"])
          ], 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$tc("saved_contacts")), 1)
          ]),
          _createVNode(AllUserComponent, { resetForm: _unref(resetForm) }, null, 8, ["resetForm"])
        ])
      ])
    ], 32),
    _withDirectives(_createElementVNode("div", _hoisted_17, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allErrors.value, (error) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "uppercase text-raleway-13 t-danger text-center",
          key: error
        }, [
          (typeof error === 'object')
            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(Object.keys(error) + ": " + Object.values(error)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(error), 1))
        ]))
      }), 128))
    ], 512), [
      [_vShow, allErrors.value]
    ])
  ], 64))
}
}

})